module.exports = __webpack_public_path__ + "img/30Years.371b3a3c.jpg";